import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Platforms from "@/components/site/Platforms";
import ComingSoon from "@/components/site/ComingSoon";
import Footer from "@/components/site/Footer";

const Home = () => {
    return (
        <div className="App bg-offwhite text-ink min-h-screen">
            <Header />
            <main>
                <Hero />
                <About />
                <Platforms />
                <ComingSoon />
            </main>
            <Footer />
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Home />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
